
<div class="text-center" style="padding: 1em;">
  <img src="/images/under-construction.png" class="img-responsive" style="max-width: 90%;margin:.5em auto;">
  <H1 align="center" style="font-size: 50px;color: #b4b4b4;text-transform: uppercase;">EN CONSTRUCCIÓN</H1>
</div>
